<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { KanbanLogItemInfo } from '@widgets/kanban-comments'
import { useListsStore } from '@shared/model'
import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'
import { KanbanPriority } from '@shared/ui/kanban'

defineOptions({
  name: 'TutorKanbanLogPriority',
})

defineProps<{
  actor: KanbanLogActor | null
  oldValue: string
  value: string
}>()

const listsStore = useListsStore()
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      v-if="actor"
      label="change priority"
      :actor="actor"
    />
    <AppText
      v-else
      name="body2"
      color="slate-400"
      class="unassigned"
    >
      changed automatically
    </AppText>
    <div class="kanban-log-field__row">
      <KanbanPriority
        v-if="oldValue"
        :status="Number(oldValue)"
        :kanban-priority="listsStore.getLists?.kanban_priority || {}"
      />
      <IconContainer v-if="oldValue">
        <FontAwesomeIcon :icon="faArrowRight" />
      </IconContainer>
      <KanbanPriority
        :status="Number(value)"
        :kanban-priority="listsStore.getLists?.kanban_priority || {}"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />